"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as r } from "react/jsx-runtime";
import { useIsInverseVariant as s } from "../../theme-variant-context.js";
import { vars as l } from "../../skins/skin-contract.css-mistica.js";
const t = (_param)=>{
    var { color: a, size: c = 24 } = _param, o = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const e = s(), n = a !== null && a !== void 0 ? a : e ? l.colors.inverse : l.colors.neutralHigh;
    return /* @__PURE__ */ r("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, o), {
        children: /* @__PURE__ */ r("path", {
            fill: n,
            d: "M16.93 3.987c3.027.24 4.092 2.773 4.092 4.958 0 .56-.084 1.896-.788 3.059.703 1.16.787 2.49.787 3.05 0 2.202-1.08 4.757-4.095 4.97-.493 1.165-1.532 1.82-2.924 1.82-.91 0-1.555-.443-1.992-.966-.414.49-1.061.966-2.017.966-1.394 0-2.436-.661-2.927-1.83-3.028-.243-4.092-2.775-4.092-4.96 0-.56.084-1.896.787-3.056-.703-1.157-.787-2.49-.787-3.05 0-2.202 1.084-4.757 4.095-4.97.493-1.165 1.532-1.82 2.924-1.82.91 0 1.555.442 1.992.966.415-.49 1.062-.966 2.017-.966 1.395 0 2.437.658 2.927 1.829m-.43 14.717.012.003c2.848-.048 3.154-2.563 3.145-3.661 0-.381-.056-1.69-.77-2.628-.745-.776-1.905-.728-2.247-.692l-.22.024-.082.01q-.11.014-.289.053a.675.675 0 0 1-.812-.495.66.66 0 0 1 .507-.796 5.5 5.5 0 0 1 .76-.115h.005c.02-.064 0-.132-.093-.227-.257-.263-.277-.714-.005-.966s.67-.275.927-.009l.07.073c.305.314.493.743.46 1.196.434.082.91.244 1.36.527.39-.835.432-1.748.432-2.056 0-1.1-.308-3.658-3.154-3.658h-.008c-.636.008-.914.512-1.026.82l-.044.138-1.295-.395.062-.182c.207-.577.653-1.174 1.314-1.488-.305-.47-.796-.7-1.507-.7-.798 0-1.202.77-1.317 1.034-.002.263-.008.885-.008 1.058v12.85c.006.136.003.697 0 .924.084.26.44 1.168 1.325 1.168.706 0 1.204-.238 1.512-.71a3 3 0 0 1-.397-.212q-.766-.493-1.012-1.196a.655.655 0 0 1 .423-.84.68.68 0 0 1 .86.414c.062.18.222.353.471.513.238.154.473.221.641.221m-6.507 1.812c.802 0 1.205-.77 1.323-1.028.002-.266.008-.885.008-1.058V5.578a34 34 0 0 1 0-.924c-.084-.258-.44-1.168-1.325-1.168-.686 0-1.17.23-1.482.675.712.302 1.174.91 1.39 1.512l.05.149a.674.674 0 0 1-.65.888.66.66 0 0 1-.63-.443l-.053-.162c-.11-.306-.415-.816-1.05-.816h-.006c-2.925 0-3.233 2.558-3.233 3.659 0 .372.06 1.633.731 2.566.14.106.348.182.622.204l.017.001c.257.016.954.057 1.045-.81l.011-.12a.67.67 0 0 1 .717-.626.67.67 0 0 1 .639.7l-.017.18c-.076.714-.46 1.49-1.283 1.83.008.07.053.125.182.173.345.129.563.52.434.86-.103.271-.341.448-.61.448a.6.6 0 0 1-.208-.034l-.117-.042c-.527-.196-.964-.638-1.028-1.255a3 3 0 0 1-.65-.145c-.446.865-.49 1.854-.49 2.176 0 1.098.308 3.658 3.154 3.658h.003l.006.002.013.001.034-.005a.2.2 0 0 1 .056-.006c.176.003.403-.064.641-.219.25-.16.41-.333.47-.512a.68.68 0 0 1 .86-.415.66.66 0 0 1 .424.84c-.16.468-.502.869-1.012 1.197q-.236.149-.473.244c.308.453.79.677 1.487.677"
        })
    }));
}, v = t;
export { v as default };
